define(["require", "exports", "tslib", "file-saver", "jszip"], function (require, exports, tslib_1, file_saver_1, jszip_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.exportTxt2Zip = void 0;
    jszip_1 = (0, tslib_1.__importDefault)(jszip_1);
    var exportTxt2Zip = function (th, jsonData, txtName, zipName) {
        if (txtName === void 0) { txtName = 'file'; }
        if (zipName === void 0) { zipName = 'file'; }
        var zip = new jszip_1.default();
        var data = jsonData;
        var txtData = "".concat(th, "\r\n");
        data.forEach(function (row) {
            var tempStr = '';
            tempStr = row.toString();
            txtData += "".concat(tempStr, "\r\n");
        });
        zip.file("".concat(txtName, ".txt"), txtData);
        zip.generateAsync({
            type: 'blob'
        }).then(function (blob) {
            (0, file_saver_1.saveAs)(blob, "".concat(zipName, ".zip"));
        }, function (err) {
            alert('Zip export failed: ' + err.message);
        });
    };
    exports.exportTxt2Zip = exportTxt2Zip;
});
//# sourceMappingURL=UtilsZip.js.map